<ng-template [ngIf]="labelText.length > 0">
    <label><small>{{ labelText }}
        <ng-template [ngIf]="showTimeFormatInfo">
             ({{ 'his_time' | translate }})
        </ng-template>
    </small></label>
</ng-template>
<input [(ngModel)]="value" [textMask]="{mask: maskDateHour}" (change)="change()" class="form-control form-control-sm" placeholder="00:00:00"
       type="text"/>
